import { Stack } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "../../routing/ProtectedRoute";
import ErrorBoundary from "../../common/ErrorBoundary";

const StudentLayout = () => {
  const { pathname } = useLocation();

  return (
    <ProtectedRoute>
      <Stack p={3}>
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
      </Stack>
    </ProtectedRoute>
  );
};

export default StudentLayout;
